export default __webpack_public_path__ + "static/home-banner1-cd4003efd87d36925ab9c938a617f541.jpg";